import React from 'react'

const GoogleMap = () => {
    return (
        <div className="google-map-area section text-center section-padding-bottom">
            <div className="container">
                <div className="contact-map-area" data-aos="fade-up">
                    <iframe
                        className="contact-map" title="google-map-iframe"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3107.214180574291!2d-77.20466872269388!3d38.850454049470535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5ed899569087087%3A0xa9c7bf280075e383!2sFounders%20Insulation!5e0!3m2!1sen!2sus!4v1687790977462!5m2!1sen!2sus"
                        width="600" height="450" style={{border:0}} allowFullScreen="" loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </div>
    )
}

export default GoogleMap;
